import GoalIcon from "./GoalIcon";
export default GoalIcon;
